<div class="h-full flex flex-col" [class]="floatingPageClasses()">
  <h5
    class="text-neutral-900 font-semibold text-2xl"
    [class.mb-lg]="floating()">
    {{ 'department_list_screen_title' | transloco }}
  </h5>

  <ng-template #tableActionSectionRef>
    <a
      class="flex items-center bg-primary-500 text-white font-medium text-sm py-sm px-2xl border-none rounded-md gap-sm"
      [routerLink]="[`${ADMIN_ROUTES.DEPARTMENTS.FORM}` | tenantPath: 'admin']"
      id="department_list_screen_new_department_button">
      <lib-add-icon [iconClass]="'size-5 text-white'" />

      <span class="hidden md:block">
        {{ 'department_list_screen_new_department_button' | transloco }}
      </span>
    </a>
  </ng-template>

  <lib-filtered-table
    [tableId]="'department_table'"
    [tableTitle]="'department_list_screen_subtitle' | transloco"
    [dataSource]="departmentList()"
    [titleClass]="
      floating() ? '' : 'w-full mb-2xl pb-lg border-b border-neutral-200'
    "
    [lastColumnAlignment]="'justify-end'"
    [meta]="meta()"
    [columns]="columns()"
    [isLoadingData]="isLoading()"
    [tableFilterTabs]="tableFilterTabs()"
    [(payload)]="payload"
    [tableActionSectionRef]="tableActionSectionRef"
    [isTableExportable]="false"
    [showSearch]="false"
    [tableColumnTemplates]="[
      { template: number, identifier: '' },
      { template: name, identifier: '' },
      { template: parent, identifier: '' },
      { template: manager, identifier: '' },
      { template: total_users, identifier: '' },
      { template: status, identifier: DEPARTMENTS_COLUMN_IDENTIFIERS.STATUS },
      { template: action, identifier: '' },
    ]"
    [applyOnStreamChanges]="getDepartmentList$"
    (streamSucceeds)="handleDepartmentListSuccess($event)"
    (handleApiCall)="getDepartmentList()"
    (handleViewIconClick)="viewUserDetails($event)" />
</div>

<ng-template #number let-i="i">
  @let metaData = meta();
  @if (metaData) {
    {{ (metaData.current_page - 1) * metaData.per_page + (i + 1) }}
  }
</ng-template>

<ng-template #name let-row>
  <div class="flex items-center gap-md">
    @if (row.image) {
      <img
        [src]="row.image.url"
        [alt]="row.image.name"
        width="28px"
        height="28px"
        class="rounded-sm size-7" />
    } @else {
      <span
        class="rounded-sm bg-primary-50 text-primary-500 flex justify-center items-center size-7">
        {{ row.name | avatar }}
      </span>
    }
    <span class="font-medium text-xs">
      {{ row.name | truncate }}
    </span>
  </div>
</ng-template>

<ng-template #parent let-row>
  @if (row.parent) {
    <div class="flex items-center gap-md">
      @if (row.parent.image) {
        <img
          [src]="row.parent.image.url"
          [alt]="row.parent.image.name"
          width="28px"
          height="28px"
          class="rounded-sm size-7" />
      } @else {
        <span
          class="rounded-sm bg-primary-50 text-primary-500 flex justify-center items-center size-7">
          {{ row.parent.name | avatar }}
        </span>
      }

      <span class="font-medium text-xs">
        {{ row.parent.name | truncate }}
      </span>
    </div>
  }
</ng-template>

<ng-template #manager let-row>
  @if (row.direct_manager) {
    <div class="flex items-center gap-md">
      <div
        class="avatar flex items-center justify-center rounded-full p-lg bg-primary-50">
        <span class="text-xs text-primary-500">
          {{ row.direct_manager.name | avatar }}
        </span>
      </div>

      <span class="text-xs font-medium text-neutral-900">
        {{ row.direct_manager.name }}
      </span>
    </div>
  }
</ng-template>

<ng-template #total_users let-row>
  {{ row.users_count }}
</ng-template>

<ng-template #status let-row>
  @if (row.state) {
    <lib-badge
      [label]="row.state.label"
      [badgeClass]="
        'px-sm border-none text-xs font-medium text-white ' +
        (row.state.value | userStatus)
      " />
  }
</ng-template>

<ng-template #action let-row>
  <lib-action-list
    [parentName]="'department_table'"
    [menuItems]="actionMenuItems()"
    (menuToggled)="selectedDepartment.set(row)"
    (itemClick)="handleAction($event, row)" />
</ng-template>

<ng-template #deactivate>
  <div class="text-center">
    <div
      class="inline-flex justify-center items-center bg-destructive-50 p-sm rounded-full mb-xl w-[4rem] h-[4rem]">
      <lib-close-square-icon
        viewBox="0 0 30 30"
        width="27"
        height="27"
        iconClass="text-destructive-500" />
    </div>
  </div>

  <p class="text-lg text-center font-medium mb-sm">
    {{ 'deactivate_department_modal_title' | transloco }}
  </p>

  <p class="text-sm text-neutral-500 text-center mb-4xl">
    {{ 'deactivate_department_modal_description' | transloco }}
    <span class="font-medium text-primary-500">
      {{ 'deactivate_department_modal_highlighted_description' | transloco }}
    </span>
  </p>

  <div class="flex flex-col gap-md text-base font-medium">
    <button
      [class.opacity-30]="isDepartmentStateLoading()"
      [disabled]="isDepartmentStateLoading()"
      (click)="deactivateDepartment()"
      class="bg-destructive-500 py-sm rounded-md text-white text-base cursor-pointer">
      {{
        'deactivate_department_modal_deactivate_department_button' | transloco
      }}
    </button>

    <button
      (click)="closeModal()"
      class="text-neutral-700 bg-white border border-neutral-300 py-sm rounded-md text-base cursor-pointer">
      {{ 'deactivate_department_modal_no_keep_it_button' | transloco }}
    </button>
  </div>
</ng-template>

<ng-template #activate>
  <div class="text-center">
    <div
      class="inline-flex justify-center items-center bg-primary-50 p-sm rounded-full mb-xl img-width-container">
      <lib-tick-square-icon iconClass="size-8 text-primary-500" />
    </div>
  </div>

  <p class="text-lg text-center font-medium mb-sm">
    {{ 'activate_department_modal_title' | transloco }}
  </p>

  <p class="text-sm text-neutral-500 text-center mb-4xl">
    {{ 'activate_department_modal_description' | transloco }}
    <span class="font-medium text-primary-500 block">
      {{ 'activate_department_modal_highlighted_description' | transloco }}
    </span>
  </p>

  <div class="flex flex-col gap-md text-base font-medium">
    <button
      [disabled]="isDepartmentStateLoading()"
      (click)="activateDepartment()"
      class="bg-primary-500 py-sm rounded-md text-white text-base cursor-pointer">
      {{ 'activate_department_modal_activate_department_button' | transloco }}
    </button>

    <button
      (click)="closeModal()"
      class="text-neutral-700 bg-white border border-neutral-300 py-sm rounded-md text-base cursor-pointer">
      {{ 'activate_department_modal_cancel_button' | transloco }}
    </button>
  </div>
</ng-template>

<ng-template #deleteRecord>
  <div class="text-center">
    <div
      class="inline-flex justify-center items-center bg-destructive-50 p-sm rounded-full mb-xl w-[4rem] h-[4rem]">
      <lib-delete-icon [iconClass]="'size-8 text-destructive-500'" />
    </div>
  </div>

  <p class="text-lg text-center font-medium mb-sm">
    {{ 'delete_department_modal_title' | transloco }}
  </p>

  <p class="text-sm text-neutral-500 text-center mb-4xl">
    {{ 'delete_department_modal_description' | transloco }}
  </p>

  <div class="flex flex-col gap-md text-base font-medium">
    <button
      [class.opacity-30]="isDepartmentStateLoading()"
      [disabled]="isDepartmentStateLoading()"
      (click)="deleteDepartment()"
      class="bg-destructive-500 py-sm rounded-md text-white text-base cursor-pointer">
      {{ 'delete_department_modal_delete_department_button' | transloco }}
    </button>

    <button
      (click)="closeModal()"
      class="text-neutral-700 bg-white border border-neutral-300 py-sm rounded-md text-base cursor-pointer">
      {{ 'delete_department_modal_cancel_button' | transloco }}
    </button>
  </div>
</ng-template>
